import * as React from 'react';

import Button from 'antd/lib/button';
import Dropdown from 'antd/lib/dropdown';

import defaultGearIcon from 'one-ui-graphics/svg/gear.svg';

import {
    Props,
} from 'one-ui';

import {
    Box,
    BoxBody,
    BoxHeader,
} from 'one-ui-box';

import {
    IconSize,
    IconPosition,
} from 'one-ui-gear';

import {
    useCtx,
} from 'one-ui-provider';

import { Image_URL } from 'one-ui-image';

export interface CardProps extends Props {
    note?: string;
    title?: string;
    body: JSX.Element;
    extended?: JSX.Element;
    gearIcon?: string,
    gearIconWidth?: string;
    gearIconHeight?: string;
    gearIconSize?: IconSize;
    gearActions?: JSX.Element;
    gearIconPosition?: IconPosition;
}

export const Card = ({
    body,
    note,
    title,
    extended,
    gearActions,
    gearIconWidth = '12',
    gearIconHeight = '12',
    gearIconSize = 'small',
    gearIcon = defaultGearIcon,
    gearIconPosition = 'bottomRight',
}: CardProps): JSX.Element => {
    const {
        resolver,
        static_resource_url,
    } = useCtx();

    return (
        <Box>
            <BoxHeader title={title} note={note}>
                {extended}
                {gearActions && (
                    <Dropdown overlay={gearActions} placement={gearIconPosition}>
                        <Button size={gearIconSize} className="ant-btn--gear">
                            <img
                                src={Image_URL(resolver(gearIcon), `${static_resource_url}gear.1a9c9834.svg`)}
                                width={gearIconWidth}
                                height={gearIconHeight}
                                draggable="false"
                            />
                        </Button>
                    </Dropdown>
                )}
            </BoxHeader>
            <BoxBody>
                {body}
            </BoxBody>
        </Box >
    );
}
